export default __webpack_public_path__ + "static/media/onboarding_guide_3.ea2ec744.png";